// src/mixins/BrowserPrintMixin.js
export default {
    data() {
        return {
            selectedDevice: null,
            devices: [],
        };
    },
    methods: {
        initBrowserPrint() {
            if (!window.BrowserPrint) {
                this.$message.error("请先安装浏览器打印插件");
                return;
            }
            BrowserPrint.getDefaultDevice("printer", device => {
                this.selectedDevice = device;
                if (!this.devices.find(d => d.uid === device.uid)) {
                    this.devices.push(device);
                }
                // 获取其他设备
                BrowserPrint.getLocalDevices(deviceList => {
                    deviceList.forEach(dev => {
                        if (!this.devices.find(d => d.uid === dev.uid)) {
                            this.devices.push(dev);
                        }
                    });
                }, this.handleError, "printer");
            }, this.handleError);
        },

        changeDeviceByUid(uid) {
            const found = this.devices.find(d => d.uid === uid);
            if (found) this.selectedDevice = found;
        },

        sendZPL(zpl) {
            if (!this.selectedDevice) {
                console.error("No selected printer");
                return;
            }
            this.selectedDevice.send(zpl, () => {
                console.log("ZPL sent successfully");
            }, this.handleError);
        },
        async sendMultipleZPLs(labels) {
            if (!this.selectedDevice) {
                this.$message.warning("打印设备尚未连接，请稍后再试");
                throw new Error("打印设备尚未连接，请稍后再试");
            }
            console.log("Sending multiple ZPLs", labels);
            for (let zpl of labels) {
                await new Promise((resolve, reject) => {
                    this.selectedDevice.send(zpl, () => {
                        this.$message("打印指令发送成功");
                        resolve();
                    }, (err) => {
                        this.$message("打印指令发送失败");
                        console.log("Error:", err)
                        reject(err);
                    });
                });
                await sleep(1000)
            }
            // 定义 sleep 函数
            function sleep(ms) {
                return new Promise(resolve => setTimeout(resolve, ms));
            }
        },

        readRFID() {
            if (!this.selectedDevice) {
                console.error("No selected printer");
                return;
            }
            this.selectedDevice.read(this.handleReadResult, this.handleError);
        },

        getAppConfig() {
            BrowserPrint.getApplicationConfiguration(config => {
                alert(JSON.stringify(config));
            }, err => {
                alert(JSON.stringify(new BrowserPrint.ApplicationConfiguration()));
            });
        },

        handleReadResult(data) {
            if (!data) {
                alert("No Response from Device");
            } else {
                alert("Read: " + data);
            }
        },

        handleError(error) {
            throw  new Error(error);
        },

        getDeviceList() {
            BrowserPrint.getLocalDevices(deviceList => {
                alert("Devices:\n" + JSON.stringify(deviceList, null, 4));
            }, this.handleError, "printer");
        },



        /**
         * 生成完整的居中文本打印 ZPL 指令
         * @param {Object} options
         * @param {string} options.text 要打印的文字内容
         * @param {number} options.labelWidth 标签宽度（点）
         * @param {number} options.fontHeight 字体高度（点）
         * @param {number} [options.fontWidth] 字体宽度（点，默认等于高度）
         * @param {string} [options.fontPath] 字体路径，如 E:SIMHEI.FNT
         * @param {string} [options.alias] 字体别名，如 Z
         * @param {number} [options.y] Y 坐标
         * @returns {string} 生成的 ZPL 指令
         */
        generateCenteredTextZPL({
                                    epcCode,
                                    text,
                                    labelWidth,
                                    fontHeight,
                                    fontWidth ,
                                    y = 100
                                }) {
            function getTextWidth(text, fontWidth) {
                return text.length * fontWidth;
            }

            /**
             * 计算居中的起始坐标
             */
            function getCenteredStart(labelWidth, contentWidth) {
                return Math.floor((labelWidth - contentWidth) / 2);
            }
            const contentWidth = getTextWidth(text, fontWidth);
            const startX = getCenteredStart(labelWidth, contentWidth);
            // return `^XA^CI28^CW${alias},${fontPath}^FO${startX},${y}^A@N,${fontHeight},${fontWidth},${alias}:${fontPath}^FD${text}^FS^XZ`.trim();
            return `^XA^RS8^RFW,H,0,24,^FD${epcCode}^FS^RFR,H,0,8^FS^FO${startX},${y}^A0N,${fontHeight},${fontWidth}^FD${text}^FS^XZ`.trim();
        },
    },
    destroyed() {
        if (this.selectedDevice && typeof this.selectedDevice.disconnect === 'function') {
            try {
                this.selectedDevice.disconnect();
            } catch (e) {
                console.warn("Disconnect failed", e);
            }
        }
    },
}
